"use strict";
exports.__esModule = true;
var React = require("react");
var GoogleMapContext_1 = require("../context/GoogleMapContext");
var operation_1 = require("../googlemap/operation");
var format_1 = require("../googlemap/format");
var googleMapTextLabel = function (props) {
    var _a = React.useContext(GoogleMapContext_1.GoogleMapContext), map = _a.map, bound = _a.bound, setBound = _a.setBound, zoom = _a.zoom;
    var _b = React.useState(null), mapObject = _b[0], setMapObject = _b[1];
    var mapObjectRef = React.useRef(null);
    var createTextLabel = function () {
        if (typeof google === 'undefined')
            return;
        var gLatLng = new google.maps.LatLng({
            lat: props.center.lat,
            lng: props.center.lng
        });
        var title = props.title ? props.title : (props.value ? format_1.toPrice(props.value) : 'N/A');
        var pin = new FaTextLabel(map, gLatLng, title, props.count, props.active, props.zIndex);
        google.maps.event.addDomListener(pin, 'click', function () {
            if (props.onClick)
                props.onClick([props]);
        });
        setMapObject(pin);
        operation_1.mapAddObject(map, pin);
        mapObjectRef.current = pin;
        return pin;
    };
    React.useEffect(function () {
        return function () {
            // umount mapObject using ref
            if (mapObjectRef.current)
                operation_1.mapRemoveMarker(mapObjectRef.current);
        };
    }, []);
    React.useEffect(function () {
        if (bound) {
            if (zoom === -1) {
                bound.extend(props.center);
                setBound(bound);
                map.fitBounds(bound);
            }
            if (zoom === -2) {
                var referenceCenter = map.getCenter();
                var markerCenter = props.center;
                var opposite = {
                    lat: referenceCenter.lat() - (markerCenter.lat - referenceCenter.lat()),
                    lng: referenceCenter.lng() - (markerCenter.lng - referenceCenter.lng())
                };
                bound.extend(props.center);
                bound.extend(opposite);
                setBound(bound);
                map.fitBounds(bound);
            }
        }
    }, [zoom]);
    var renderContent = function () {
        if (!mapObject)
            createTextLabel();
        return null;
    };
    return map ? renderContent() : null;
};
exports.GoogleMapTextLabel = googleMapTextLabel;
